// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.margin {
  margin-top: 20%;
  margin-left: 5%;
  margin-right: 5%;
  margin-bottom: 20%;
}

.title {
  font-style: bold;
  font-weight: 700;
  font-size: 20px;
  color: black;
  text-align: center;
}

.body {
  margin-top: 10%;
  font-size: 12px;
  color: #646464;
  text-align: center;
}

.image {
  margin-top: 10%;
  margin-bottom: 10%;
}
.image img {
  display: block;
  height: 150px;
  width: 150px;
  margin: auto;
  justify-content: center;
}

.button-row {
  margin-top: 5%;
  margin-bottom: 5%;
}

.login-btn {
  font-weight: bold;
  font-size: 16px;
  text-align: center;
  width: 100%;
  color: black;
  --border-color: #C4C4C4;
}`, "",{"version":3,"sources":["webpack://./src/components/popover/popover.component.scss","webpack://./../../Open%20Source/cashloan-mobile-app/src/components/popover/popover.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;ACCJ;;ADEA;EACI,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;ACCJ;;ADEA;EACI,eAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;ACCJ;;ADEA;EACI,eAAA;EACA,kBAAA;ACCJ;ADAI;EACI,cAAA;EACA,aAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;ACER;;ADEA;EACC,cAAA;EACA,iBAAA;ACCD;;ADEA;EACI,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;ACCJ","sourcesContent":[".margin {\n    margin-top: 20%;\n    margin-left: 5%;\n    margin-right: 5%;\n    margin-bottom: 20%;\n}\n\n.title {\n    font-style: bold;\n    font-weight: 700;\n    font-size: 20px;\n    color: black;\n    text-align: center;\n}\n\n.body {\n    margin-top: 10%;\n    font-size: 12px;\n    color: #646464;\n    text-align: center;  \n}\n\n.image {\n    margin-top: 10%;\n    margin-bottom: 10%;\n    img {\n        display: block;\n        height: 150px;\n        width: 150px;\n        margin: auto;\n        justify-content: center;\n    }\n}\n\n.button-row {\n\tmargin-top: 5%;\n\tmargin-bottom: 5%;\n}\n\n.login-btn {\n    font-weight: bold;\n    font-size: 16px;\n    text-align: center;\n    width: 100%;\n    color: black;\n    --border-color: #C4C4C4;\n}",".margin {\n  margin-top: 20%;\n  margin-left: 5%;\n  margin-right: 5%;\n  margin-bottom: 20%;\n}\n\n.title {\n  font-style: bold;\n  font-weight: 700;\n  font-size: 20px;\n  color: black;\n  text-align: center;\n}\n\n.body {\n  margin-top: 10%;\n  font-size: 12px;\n  color: #646464;\n  text-align: center;\n}\n\n.image {\n  margin-top: 10%;\n  margin-bottom: 10%;\n}\n.image img {\n  display: block;\n  height: 150px;\n  width: 150px;\n  margin: auto;\n  justify-content: center;\n}\n\n.button-row {\n  margin-top: 5%;\n  margin-bottom: 5%;\n}\n\n.login-btn {\n  font-weight: bold;\n  font-size: 16px;\n  text-align: center;\n  width: 100%;\n  color: black;\n  --border-color: #C4C4C4;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
